// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  hmr: false,
  //UAT Credentials
  firebaseConfig: {
    apiKey: "AIzaSyDWAQbgyDa_xsfiRyapvsGl26wVolGsmB4",
    authDomain: "fs-uat.firebaseapp.com",
    databaseURL: "https://fs-uat-default-rtdb.firebaseio.com",
    projectId: "fs-uat",
    storageBucket: "fs-uat.firebasestorage.app",
    messagingSenderId: "484507369457",
    appId: "1:484507369457:web:7455cabe1378206cface50",
    measurementId: "G-6ZCPEJDXTD"
  },
    //AWS Cred
  bucket_name: 'fs-development',
    accessKeyId: 'AKIAVU6X5IOK3U4TSUMY',
    secretAccessKey: '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',
    region: 'us-east-1',
    qboConfig: {
        client_id: 'AB35Nv3SpdqTMHXerUdJ79CR1ko8iBv8Jiv5yCTpjKwfahweFa',
        client_secret: 'EGbfcUGFY3wdTyXMLlAIbudvbrJpUG6GakjODU8E',
        redirectUri: 'https://localhost:44354/company/integrations/qbo/callback',
        //redirectUri:'https://client.entrafield.com/company/integrations/qbo/callback',
        environment:'sandbox'
    },
  ges_system: false,
  base_url: 'https://client.entrafield.com/',
  app_url: 'https://client.entrafield.com/',
  signal_r_hub: 'https://fieldstarr-uat-new-webservice.azurewebsites.net/',
  //help_center_url: 'https://guardsprohelpcenter.azurewebsites.net/',
  help_center_url: 'https://support.fieldstarr.com',
  brand_name: 'EntraField',
  map_id: 'fa62cebfc247080e',
  mapbox: {
    accessToken: 'pk.eyJ1IjoiZ3BtYXBnZW8iLCJhIjoiY2xzNHhzbnRiMGFuZzJsbXIwOGpyMHE2MiJ9.xYkKiVt9Q82VZ1TBcLNgGg'
  },
  firebase_app_check_site_key: "6Lf0HkstAAAAAGxDF9Fiy7cpQNzVXzapuaR0PdCF"
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
